import {
    type IAgentRuntime,
    type Memory,
    type Provider,
    type State,
    elizaLogger,
} from "@elizaos/core";
import { STRATEGY_ADDRESSES } from "../utils/constants";

const strategiesProvider: Provider = {
    name: "strategiesProvider",
    description: "Provides available yield strategy addresses on Avalanche",
    get: async (_runtime: IAgentRuntime, _message: Memory, _state: State) => {
        elizaLogger.debug("strategiesProvider::get");
        const strategies = Object.entries(STRATEGY_ADDRESSES)
            .map(([key, value]) => `${key}: ${value}`)
            .join("\n");
        return {
            text: `The available strategy addresses and their deposit tokens are:\n${strategies}`,
            data: STRATEGY_ADDRESSES
        };
    },
};

export { strategiesProvider };
